module.exports = __webpack_public_path__ + "img/thumbnail_GreaterRhea_j_normal.7da73d64.png";